import { z } from 'zod';

/** Optional location typography, independent of the ride's own title. */
export const PlaceTitleSchema = z.object({
  name: z.string().trim().min(1).max(120),
  region: z.string().trim().max(120),
}).strict();
export type PlaceTitle = z.infer<typeof PlaceTitleSchema>;

export function readPlaceTitle(value: string | null): PlaceTitle | undefined {
  return value === null ? undefined : PlaceTitleSchema.parse(JSON.parse(value));
}

/** Film seconds govern the fade during playback, seeking, and export. */
export function placeTitleOpacity(seconds: number): number {
  if (!Number.isFinite(seconds) || seconds <= 0 || seconds >= 2.8) return 0;
  if (seconds < .2) return seconds / .2;
  if (seconds <= 1.4) return 1;
  return (2.8 - seconds) / 1.4;
}

/** Match both camera transitions, including shortened approaches in five-second films. */
export function filmPlaceTitleOpacity(seconds: number, durationSeconds: number): number {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0 || seconds < 0 || seconds > durationSeconds) return 0;
  const transitionSeconds = Math.min(3, Math.max(0, (durationSeconds - 1) / 2));
  if (transitionSeconds === 0) return 0;
  const scale = 3 / transitionSeconds;
  return Math.max(placeTitleOpacity(seconds * scale), placeTitleOpacity((durationSeconds - seconds) * scale));
}
